import React from 'react';
import ProtectedRoute from './ProtectedRoute';
import UserDashboardLayout from './UserDashboardLayout';

/** Customer account shell: auth gate only (no sidebar). */
const AccountAreaLayout: React.FC = () => (
  <ProtectedRoute>
    <UserDashboardLayout />
  </ProtectedRoute>
);

export default AccountAreaLayout;
